import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxShiftTemplate from "../../util/remote/ajaxShiftTemplate";
const RegisterShiftTemplateModal = (props) => {
  const [loading, setLoading] = useState(false);
  // Station ID
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const [stationID, setStationID] = useState(station_idd);
  // User-entered shift name (TEXT now)
  const [shiftName, setShiftName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const allRowsFilled = () => stationID && shiftName && startTime && endTime;
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all fields");
      return;
    }
    const data = {
      station_id: stationID,
      shift_name: shiftName, // now text
      start_time: startTime,
      end_time: endTime,
    };
    setLoading(true);
    const response = await ajaxShiftTemplate.create_shit_templates(data);
    setLoading(false);
    if (response.status === "OK") {
      props.func();
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setShiftName("");
    setStartTime("");
    setEndTime("");
  };
  // Fetch stations
  const [stations_list, setStationsList] = useState([]);
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: Number(d.id),
          label: d.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Create Shift Template"}
      </button>
    </>
  );
  return (
    <SystemModal title="Create Shift Template" size="md" footer={RenderFooter}>
      <Toaster />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Shift Template Setup</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station Select */}
                    <div className="col-md-12 mb-3">
                      <label>Station *</label>
                      <Select
                        options={stations_list}
                        value={
                          stations_list.find(
                            (s) => s.value === Number(stationID)
                          ) || null
                        }
                        isDisabled={true}
                      />
                    </div>
                    {/* Shift Name - TEXT INPUT */}
                    <div className="col-md-12 mb-3">
                      <label>Shift Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter shift name, e.g Morning Shift"
                        value={shiftName}
                        onChange={(e) => setShiftName(e.target.value)}
                      />
                    </div>
                    {/* Start Time */}
                    <div className="col-md-6 mb-3">
                      <label>Start Time *</label>
                      <input
                        type="time"
                        className="form-control"
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                      />
                    </div>
                    {/* End Time */}
                    <div className="col-md-6 mb-3">
                      <label>End Time *</label>
                      <input
                        type="time"
                        className="form-control"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterShiftTemplateModal;
